<div class="loading-container" *ngIf="showSpinner">
  <div class="loading-gif">
    <img src="../assets/images/Spinner.gif">
  </div>
</div>

<div>
  <input
    type="file" #template_file_upload
    style="display:none"
    (change)="onTemplateFileUploadChanged()"
    name="inputTemplateFileUpload" />
</div>

<div>
  <form novalidate class="form-group"
    (ngSubmit)="onSubmit()"
    [formGroup]="manualUsageEventForm">

    <!-------------------------------------------
                Base Info
    --------------------------------------------->
    <div class="form-row form-group mb-2">

      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="aviClientSel">Avi Customer ID *</label>
        <div class="col-md-4">
          <select class="form-control"
            formControlName="aviClientId"
            id="aviClientSel"
            placeholder ="-- Choose Id --"
            [ngClass]="{'is-invalid': (manualUsageEventForm.get('aviClientId').touched || manualUsageEventForm.get('aviClientId').dirty) && !manualUsageEventForm.get('aviClientId').valid}">
            <option  [ngValue]="" disabled>-- Choose Id --</option>
            <option *ngFor="let client of sharedDataService.aviClientIds" [ngValue]="client">{{client}}</option>
          </select>
          <span class="form-control-feedback"
            *ngIf="(manualUsageEventForm.get('aviClientId').touched || manualUsageEventForm.get('aviClientId').dirty) && !manualUsageEventForm.get('aviClientId').valid">
              <span *ngIf="this.manualUsageEventForm.get('aviClientId').errors['required']">Please select an Avi Client Id.</span>
          </span>
        </div>
      </div>

      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="billingMonthSelection">Billing Month</label>
          <div class="col-md-4">
            <select class="form-control"
              id="billingMonthSelection"
              formControlName="billingMonth">
              <option [ngValue]='currentBillingMonth'>{{currentBillingMonth|date:'MMMM yyyy'}}</option>
              <option [ngValue]='prevBillingMonth'>{{prevBillingMonth|date:'MMMM yyyy'}}</option>
            </select>
          </div>
      </div>

      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="productSelection">Product *</label>
        <div class="col-md-4">
          <select class="form-control"
            formControlName="usageProduct"
            id="productSelection"
            [ngClass]="{'is-invalid': (manualUsageEventForm.get('usageProduct').touched || manualUsageEventForm.get('usageProduct').dirty) && !manualUsageEventForm.get('usageProduct').valid}">
            <option  [ngValue]='' hidden disabled>-- Choose Product --</option>
            <option *ngFor="let c of clientUsage" [ngValue]="c">{{c['productDescription']}}</option>
          </select>
          <span class="form-control-feedback"
            *ngIf="(manualUsageEventForm.get('usageProduct').touched || manualUsageEventForm.get('usageProduct').dirty) && !manualUsageEventForm.get('usageProduct').valid">
              <span *ngIf="this.manualUsageEventForm.get('usageProduct').errors['required']">Please select Usage Product from list</span>
          </span>
          <span *ngIf="manualUsageEventForm.get('usageProduct').valid && manualUsageEventForm.get('usageProduct').dirty">
                <label class ="col-form-label" style="color:rgb(0, 60, 255)">Category:</label>
                {{manualUsageEventForm.get('usageProduct').value['category']}}
          </span>
        </div>
      </div>

      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputDescription">Description</label>
        <div class="col-md-4">
          <input class ="form-control"
          type="text"
          id="inputDescription"
          formControlName="description"
          placeholder=""
          [ngClass]="{'is-invalid': (manualUsageEventForm.get('description').touched || manualUsageEventForm.get('description').dirty) && !manualUsageEventForm.get('description').valid}"/>
          <span class="form-control-feedback"
              *ngIf="(manualUsageEventForm.get('description').touched || manualUsageEventForm.get('description').dirty) && !manualUsageEventForm.get('description').valid">
              <span *ngIf="this.manualUsageEventForm.get('description').errors['required']">Please enter a description for this usage item.</span>
          </span>
        </div>
      </div>
    </div>

    <!-------------------------------------------
                Site Info component
    --------------------------------------------->
    <div class="form-row form-group mb-2" formGroupName="siteGroup">
      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputSiteName">Site Name</label>
        <div class="col-md-4">
          <input class="form-control"
          type="text"
          id="inputSiteName"
          formControlName="siteName"/>
        </div>
      </div>
      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputSiteName">City</label>
        <div class="col-md-4">
          <input class="form-control"
          type="text"
          id="inputSiteName"
          formControlName="siteCity"/>
        </div>
      </div>
      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputSiteState">State</label>
        <div class="col-md-4">
          <input class="form-control"
          type="text"
          id="inputSiteState"
          formControlName="siteState"/>
        </div>
      </div>
      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputZipcode">Zip Code</label>
        <div class="col-md-4">
          <input class="form-control"
          type="text"
          id="inputZipcode"
          maxlength="10"
          formControlName="siteZipCode"/>
        </div>
      </div>
    </div>

    <!-------------------------------------------
                Open & Close info
    --------------------------------------------->
    <div class="form-row form-group mb-2" formGroupName="ocGroup"
    *ngIf= "this.manualUsageEventForm.get('usageType').value === usageEventTypes.openClose">
      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputStoreNum">Store Number</label>
        <div class="col-md-4">
          <input class="form-control"
          type="number"
          id="inputStoreNum"
          formControlName="storeNumber"/>
        </div>
      </div>

      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputAddress">Address</label>
        <div class="col-md-4">
          <input class="form-control"
          type="text"
          id="inputAddress"
          placeholder=""
          formControlName="address"/>
        </div>
      </div>

    <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputOcAccountNumber">AccountNumber</label>
        <div class="col-md-4">
          <input class="form-control"
          type="text"
          id="inputOcAccountNumber"
          placeholder=""
          formControlName="ocAccountNumber"/>
        </div>
      </div>

      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputUtilityName">Utility Name</label>
        <div class="col-md-4">
          <input class="form-control"
          type="text"
          id="inputUtilityName"
          placeholder=""
          formControlName="utilityName"/>
        </div>
      </div>

      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputPrimarySvc">Primary Service</label>
        <div class="col-md-4">
          <input class="form-control"
          type="text"
          id="inputPrimarySvc"
          placeholder=""
          formControlName="primaryService"/>
        </div>
      </div>

      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputMeterNum">MeterNumber</label>
        <div class="col-md-4">
          <input class="form-control"
          type="text"
          id="inputMeterNum"
          placeholder=""
          formControlName="meterNumber"/>
        </div>
      </div>

      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputDateRequested">Date Requested</label>
        <div class="col-md-4">
          <input class="form-control"
            type="date"
            id="inputDateRequested"
            formControlName="dateRequested"/>
        </div>
      </div>

      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputRequester">Requester</label>
        <div class="col-md-4">
          <input class="form-control"
            type="text"
            id="inputRequester"
            formControlName="requester"/>
        </div>
      </div>
    </div>

    <!-------------------------------------------
            Late Utility Funding Adjustment
    --------------------------------------------->
    <div class="form-row form-group mb-2"
        *ngIf= "this.manualUsageEventForm.get('usageType').value === usageEventTypes.lateUtilityFundingAdjustment">
      <div class="input-group mb-2">
      <label class="col-md-2 col-form-label" for="inputAccountNumber">AccountNumber</label>
      <div class="col-md-4">
        <input class="form-control"
        type="text"
        id="inputAccountNumber"
        placeholder=""
        formControlName="accountNumber"/>
      </div>
      </div>
    </div>

    <!-------------------------------------------
              Late Funding Info
    --------------------------------------------->
    <div class="form-row form-group mb-2" formGroupName="lfGroup"
    *ngIf= "this.manualUsageEventForm.get('usageType').value === usageEventTypes.lateFunding">
      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputConsolidationID">Consolidation Id</label>
        <div class="col-md-4">
          <input class="form-control"
          type="number"
          id="inputConsolidationID"
          placeholder=""
          formControlName="consolidationID"/>
        </div>
      </div>

      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputConsolidationInvNum">Invoice Number</label>
        <div class="col-md-4">
          <input class="form-control"
          type="number"
          id="inputConsolidationInvNum"
          placeholder=""
          formControlName="consolidationInvoiceNumber"/>
        </div>
      </div>

      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputBillConsolidatedOn">Consolidated On</label>
        <div class="col-md-4">
          <input class="form-control"
          type="Date"
          id="inputBillConsolidatedOn"
          placeholder=""
          formControlName="billConsolidationDate"/>
        </div>
      </div>

      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputSrvDesciption">Service Description</label>
        <div class="col-md-4">
          <input class="form-control"
          type="text"
          id="inputSrvDesciption"
          placeholder=""
          formControlName="serviceDescription"/>
        </div>
      </div>

      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputConsodationFunded">Funded On</label>
        <div class="col-md-4">
          <input class="form-control"
          type="Date"
          id="inputConsodationFunded"
          placeholder=""
          formControlName="consolidationFundedDate"/>
        </div>
      </div>

      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputDaysToBill">Days To Bill</label>
        <div class="col-md-4">
          <input class="form-control"
          type="number"
          onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 45"
          id="inputDaysToBill"
          formControlName="daysToBill"
          [ngClass]="{'is-invalid': (manualUsageEventForm.get('lfGroup.daysToBill').touched && manualUsageEventForm.get('lfGroup.daysToBill').dirty) && !manualUsageEventForm.get('lfGroup.daysToBill').valid}">
          <span class="form-control-feedback"
          *ngIf="(manualUsageEventForm.get('lfGroup.daysToBill').touched || manualUsageEventForm.get('lfGroup.daysToBill').dirty) && !manualUsageEventForm.get('lfGroup.daysToBill').valid">
              <span *ngIf="this.manualUsageEventForm.get('lfGroup.daysToBill').errors['nonNumber']">Please enter a valid Integer.</span>
          </span>
        </div>
      </div>
    </div>

    <div class="form-row form-group mb-2">
      <div class="input-group mb-2">
        <label class="col-md-2 col-form-label" for="inputValue">Amount *</label>
        <div class="col-md-4">
          <input class="form-control"
          type="text"
          id="inputValue"
          formControlName="amount"
          cbTwoDigitDecimaNumber
          [ngClass]="{'is-invalid': (manualUsageEventForm.get('amount').touched || manualUsageEventForm.get('amount').dirty) && !manualUsageEventForm.get('amount').valid}">
        <span class="form-control-feedback"
          *ngIf="(manualUsageEventForm.get('amount').touched || manualUsageEventForm.get('amount').dirty) && !manualUsageEventForm.get('amount').valid">
          <span *ngIf="this.manualUsageEventForm.get('amount').errors['required']">Please enter an amount.</span>
        </span>
        </div>
      </div>
    </div>

    <button class="btn btn-primary"
      type="submit"
      name="btnUsageSubmit"
      [title]="manualUsageEventForm.valid ? 'Save your entered Data': 'disabled until valid data entered'"
      [disabled]="!manualUsageEventForm.valid"
      (ngSubmit)="onSubmit()">Submit
    </button>
    <br>
    <br>
    <p class="text-muted"><small>* required fields</small></p>
  </form>
</div>

<hr />
<br>

<div class="row">
  <div class="col-sm-1"></div>
  <div class="col-sm-4">
      <button type="button" class="btn btn-primary btn-md btn-block" (click)='onTemplateFileDownloadClick()' name="onTemplateFileDownloadClick">Download Bulk Usage Template</button>
      <button type="button" class="btn btn-primary btn-md btn-block" (click)='onTemplateFileUploadClick()' name="onTemplateFileUploadClick">Upload Bulk Usage File</button>
  </div>
</div>

<!--div>
  <br> FORM:
  <br> Dirty: {{manualUsageEventForm.dirty}}
  <br> Touched: {{manualUsageEventForm.touched}}
  <br> Valid: {{manualUsageEventForm.valid}}
  <br> Value: {{manualUsageEventForm.value | json}}
  <br>
  <br>
  <br> AVICLIENTID
  <br> Dirty: {{manualUsageEventForm.get('aviClientId').dirty}}
  <br> Touched: {{manualUsageEventForm.get('aviClientId').touched}}
  <br> Valid: {{manualUsageEventForm.get('aviClientId').valid}}
  <br> Value: {{manualUsageEventForm.get('aviClientId').value}}
  <br>
  <br>
  <br> DAYS TO BILL
  <br> Dirty: {{manualUsageEventForm.get('lfGroup.daysToBill').dirty}}
  <br> Touched: {{manualUsageEventForm.get('lfGroup.daysToBill').touched}}
  <br> Valid: {{manualUsageEventForm.get('lfGroup.daysToBill').valid}}
  <br> Value: {{manualUsageEventForm.get('lfGroup.daysToBill').value | json}}
  <br>
  <br>
  <br> PRODUCT
  <br> Dirty: {{manualUsageEventForm.get('usageProduct').dirty}}
  <br> Touched: {{manualUsageEventForm.get('usageProduct').touched}}
  <br> Valid: {{manualUsageEventForm.get('usageProduct').valid}}
  <br> Product: {{manualUsageEventForm.get('usageProduct').value | json}}
  <br>
  <br> AMOUNT
  <br> Dirty: {{manualUsageEventForm.get('amount').dirty}}
  <br> Touched: {{manualUsageEventForm.get('amount').touched}}
  <br> Valid: {{manualUsageEventForm.get('amount').valid}}
  <br> Product: {{manualUsageEventForm.get('amount').value | json}}
  <br> Product: {{manualUsageEventForm.get('amount').errors|json }}
  <br>
  <br>
  <br> CLIENTUSAGE LIST
  <br> list: {{clientUsage[0]|json}}
</div-->
